/**
 * @see https://umijs.org/docs/max/access#access
 * */
type Group = 'admin' | 'worker' | 'light' | 'standard' | 'premium';

const hasAnyGroup = (userGroups: string[] = [], allowed: Group[]) =>
  allowed.some((g) => userGroups.includes(g));

export default function access(initialState: any) {
  const userGroups: string[] = initialState?.currentUser?.role ?? [];

  return {
    // よく使うショートカット
    isAdmin: userGroups.includes('admin'),
    inWorker: userGroups.includes('worker'),

    // 汎用：routes 側から allowedGroups を渡せないので、
    // 「固定名のaccess関数」を必要な分だけ用意するのが現実的
    canSeeAdminMenu: hasAnyGroup(userGroups, ['admin']),
    canSeeWorkerMenu: hasAnyGroup(userGroups, ['admin', 'worker']),
    canSeePremiumMenu: hasAnyGroup(userGroups, ['admin', 'premium']),
    // ...必要な組み合わせを追加
  };
}
